import {
    HomeView,
    LoginView,
    SignUpView,
    CardexView,
    SonsView,
    ProfileView,
    PasswordView,
    PrivacyView,
    AboutUsView,
    ContactUsView,
    NotFoundView,
    FAQView,
    ServicesView
} from "./views";

import { Navigate, Routes, Route } from "react-router-dom";
import Main from "./layouts/Main";
import Simple from "./layouts/Simple";
import { useAuth } from './providers/AuthContextProvider'; 

export default function Router() {
  const { user } = useAuth();
  
  return (
    <Routes>
      {/* Redirect base to /home */}
      <Route path="/" element={<Navigate to="/home" replace />} />
      {/* Home */}
      <Route
        path="/home"
        element={
          user ? (
            <Navigate to="/sons" replace />
          ) : (
            <Simple props={<HomeView />} />
          )
        }
      />
      {/* Auth */}
      <Route
        path="/login"
        element={user ? <Navigate to="/home" replace /> : <LoginView />}
      />
      <Route
        path="/registry"
        element={user ? <Navigate to="/registry" replace /> : <SignUpView />}
      />
      <Route
        path="/password"
        element={user ? <Navigate to="/home" replace /> : <PasswordView />}
      />
      {/* Protected routes */}
      <Route
        path="/cardex"
        element={
          user ? (
            <Main props={<CardexView />} />
          ) : (
            <Navigate to="/home" replace />
          )
        }
      />
      <Route
        path="/sons"
        element={
          user ? (
            <Main props={<SonsView parentId={user.id} />} />
          ) : (
            <Navigate to="/home" replace />
          )
        }
      />
      <Route
        path="/profile"
        element={
          user ? (
            <Main props={<ProfileView user={user} />} />
          ) : (
            <Navigate to="/home" replace />
          )
        }
      />
      {/* Public routes */}
      <Route path="/privacy" element={<PrivacyView />} />
      <Route path="/about-us" element={<Simple props={<AboutUsView />} />} />
      <Route path="/contact-us" element={<Simple props={<ContactUsView />} />} />
      <Route path="/faq" element={<Simple props={<FAQView />} />} />
      <Route path="/services" element={<Simple props={<ServicesView />} />} />
      {/* 🧭 Catch-all 404 route */}
      <Route path="*" element={<Simple props={<NotFoundView />} />} />
    </Routes>
  );
}